const translations = {
  en: {
    // App
    appName: "kepti market",
    tagline: "Pass it on.",

    // Auth
    loginTitle: "kepti market",
    loginSubtitle: "The Buy & Sell group, evolved.",
    loginCredit: "Made with love by a KCS parent.",
    signInGoogle: "Sign in with Google",

    // Navigation
    browse: "Browse",
    myListings: "My Listings",
    sell: "Sell",
    profile: "Profile",

    // Browse
    searchPlaceholder: "Search listings...",
    allCategories: "All",
    noListings: "No listings yet.",
    noListingsSearch: "No listings match your search.",
    free: "Free",
    movingSale: "Moving sale",
    saved: "Saved",

    // Categories
    furnitureHome: "Furniture & Home",
    bikesSports: "Bikes & Sports",
    kidsClothing: "Kids' Clothing & Shoes",
    electronics: "Electronics",
    booksToys: "Books & Toys",
    babyToddler: "Baby & Toddler",
    other: "Other",

    // Conditions
    likeNew: "Like new",
    good: "Good condition",
    used: "Well used",

    // Payment
    mbway: "MBWay",
    cash: "Cash",
    both: "MBWay or cash",

    // Locations — Cascais line
    cascais: "Cascais",
    estoril: "Estoril",
    birreTires: "Birre / Areia / Tires",
    saoDomingos: "São Domingos de Rana",
    alcabideche: "Alcabideche",
    parede: "Parede",
    carcavelos: "Carcavelos",
    saoJoaoEstoril: "São João do Estoril",
    // Locations — Oeiras
    oeiras: "Oeiras",
    miraflores: "Miraflores",
    alges: "Algés",
    portoSalvo: "Porto Salvo",
    barcarena: "Barcarena",
    // Locations — Lisbon
    belemRestelo: "Belém / Restelo",
    principeReal: "Príncipe Real / Estrela",
    campoOurique: "Campo de Ourique / Lapa",
    chiado: "Chiado / Bairro Alto",
    avenidas: "Avenidas Novas",
    parqueNacoes: "Parque das Nações",
    // Locations — Sintra / North
    sintra: "Sintra",
    queluz: "Queluz",
    amadora: "Amadora",
    // Locations — Other
    otherRiver: "Other side of river",
    outsideLisbon: "Outside Lisbon",

    // Post listing
    sellSomething: "Sell something",
    addPhoto: "Add photo",
    changePhoto: "Change photo",
    title: "Title",
    titlePlaceholder: "e.g. IKEA Kivik sofa, grey",
    category: "Category",
    selectCategory: "Select a category",
    price: "Price (€)",
    pricePlaceholder: "0 for free",
    condition: "Condition",
    selectCondition: "Select condition",
    payment: "Payment",
    selectPayment: "Select payment",
    location: "Pickup location",
    selectLocation: "Select area",
    size: "Size",
    filterBySize: "Filter by size",
    clearSize: "Clear",
    allSizes: "All sizes",
    description: "Description (optional)",
    descriptionPlaceholder: "Any extra details...",
    movingSaleCheck: "This is a moving sale",
    postListing: "Post listing",
    posting: "Posting...",
    whatsappRequired: "Please add your WhatsApp number in your profile before posting.",
    photoRequired: "Please add a photo.",
    titleRequired: "Please add a title.",
    categoryRequired: "Please select a category.",
    priceRequired: "Please enter a price (0 for free).",
    conditionRequired: "Please select a condition.",
    paymentRequired: "Please select a payment method.",
    locationRequired: "Please select a pickup location.",

    // Listing detail
    contactSeller: "Contact seller",
    markAsSold: "Mark as sold",
    editListing: "Edit listing",
    deleteListing: "Delete listing",
    flagListing: "Report listing",
    confirmDelete: "Are you sure you want to delete this listing?",
    confirmSold: "Mark this listing as sold?",
    pickup: "Pickup",
    postedBy: "Posted by",
    savelisting: "Save listing",
    unsaveListing: "Unsave listing",

    // Edit listing
    editPrice: "Edit price",
    editNote: "Edit description",
    editLocation: "Edit location",
    saveChanges: "Save changes",
    saving: "Saving...",

    // My listings
    active: "Active",
    sold: "Sold",
    noActiveListings: "No active listings.",
    noSoldListings: "No sold listings yet.",
    noSavedListings: "Nothing saved yet.",
    startSelling: "Post your first listing",

    // Profile
    whatsappNumber: "WhatsApp number",
    whatsappPlaceholder: "+351 9xx xxx xxx",
    saveNumber: "Save number",
    howItWorks: "How it works",
    howItWorksText: "Browse listings posted by parents in your community. See something you like? Contact the seller directly on WhatsApp and arrange a local pickup. Free to use — pass it on.",
    privacy: "Privacy & disclaimer",
    privacyText: "kepti market is a free community tool, not a shop. All transactions happen directly between buyers and sellers — kepti is just the notice board. We can't verify listings or guarantee exchanges, so use your judgement and stay safe.",
    contactModerator: "Contact moderator",
    signOut: "Sign out",
    version: "kepti market",
  }
};

export default translations;
